/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Main.module.css';
import data from '../../logic/data';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class ExampleHeader extends Component {
  render() {
    const {exampleIdx} = this.props;
    const subHeader = data.examples[exampleIdx].subHeaderText.map((el, idx) => 
      <span key={idx}>{el}</span>);
    return (
      <div className={styles.heading}>
        <h2 className={styles.mainHeading}>
          {data.examples[exampleIdx].headerText}
        </h2>
        <div className={styles.subHeading}>{subHeader}</div>
      </div>
    );
  }
}

export default ExampleHeader;
